import LegalDocument from "./LegalDocument";

export default function Privacy() {
  return <LegalDocument kind="privacy" />;
}
